import React from "react";
import RainbowText from "./RainbowText";

export default function Footer() {
  return (
    <footer>
      <span className="tape l" />
      <span className="tape r" />
      <div className="sig">
        <RainbowText text="LoREMi G" className="wordmark" />
      </div>
      <div className="fine">
        EST. 2026 · CDMX · Hecho con confeti, mucho pastel y cero aburrimiento.
      </div>
    </footer>
  );
}
